import axios from 'axios'

export default {
    find(id) {
        return axios.get(id)
    },
    login(username, password) {
        return axios.post('/api/getToken', {
            username: username,
            password: password
        })
    },
    changePassword(userId, password, confirmationToken) {
        return axios.post('/api/security/change-password', {
            user: `/api/security-users/${userId}`,
            password: password,
            confirmationToken: confirmationToken
        })
    },
    isConfirmationTokenValid(userId, confirmationToken) {
        return axios.post(
            '/api/security/is-confirmation-token-valid',
            {
                user: `/api/security-users/${userId}`,
                confirmationToken: confirmationToken
            },
            { headers: { Authorization: '' } }
        )
    },
    requestPasswordReset(username, honeypot) {
        return axios.post(
            '/api/security/request-password-reset',
            {
                username: username,
                fax: honeypot
            },
            { headers: { Authorization: '' } }
        )
    }
}
